import angular from 'angular';
import { FilterService2, getStep, hasOwnProperty } from '../../tn.common';
import { LocalCarts } from '../local-carts.service/localCarts';

SavedCartsIndexFilters.$inject = [
    'localCarts',
    'tnCartFiltersService',
    '$scope',
];

export function SavedCartsIndexFilters(
    localCarts: LocalCarts,
    cartFilters: FilterService2,
    $scope
) {
    const vm = angular.extend(this, {
        activeFilters: cartFilters.get(),
        clearFilter: (filter, notify) => cartFilters.reset(filter, notify),
        clearFilters: () => cartFilters.resetAll(),
        hasFilter: (name, value) => cartFilters.hasFilter(name, value),
        toggleFilter: (name, obj) =>  cartFilters.toggle(name, obj),
        isActive: { licenseType: true, date: true, cost: true },
        carts: localCarts.getCarts(),
        filteredCarts: localCarts.getFilteredCarts(),
        currentDate: new Date(),

        priceMin: 0,
        priceMax: 0,
        priceStep: 0,
    });

    initalize();

    function initalize() {
        vm.cartFilters = localCarts.getCarts();
    }

    $scope.$watch(
        'vm.activeFilters',
        function (newFilters) {
            localCarts.setFilteredCarts(newFilters);
        },
        true
    );

    $scope.$watch(
        'vm.carts',
        function (newCarts) {
            // Only filter fully populated carts
            newCarts = newCarts.filter(
                (cart) =>
                    hasOwnProperty(cart, 'license') &&
                    cart.license.length > 0 &&
                    hasOwnProperty(cart, 'subtotal') &&
                    hasOwnProperty(cart.subtotal, 'discounted')
            );

            if (newCarts.length !== 0) {
                _countLicenseTypes(newCarts);
                _getMinMax(newCarts);
            }
        },
        true
    );

    function _getMinMax(carts) {
        const prices = carts.map((cart) => cart.subtotal.discounted);
        if (prices.length === 0 || prices.length === 1) {
            return;
        }

        vm.priceMin = Math.min(...prices);
        vm.priceMax = Math.max(...prices);
        if (vm.priceMin === vm.priceMax) {
            return;
        }

        vm.priceMin = Math.floor(vm.priceMin);
        vm.priceMax = Math.ceil(vm.priceMax);
        vm.priceStep = getStep(vm.priceMin, vm.priceMax);
        vm.activeFilters.cost = {
            min: vm.priceMin,
            max: vm.priceMax,
        };
    }

    function _countLicenseTypes(carts) {
        vm.licenseTypes.Application.count = carts.filter(function (cart) {
            return cart.license.some(function (license) {
                return license.fontRights.app.apps;
            });
        }).length;

        vm.licenseTypes.Desktop.count = carts.filter(function (cart) {
            return cart.license.some(function (license) {
                return license.fontRights.desktop.computers;
            });
        }).length;

        vm.licenseTypes.Epub.count = carts.filter(function (cart) {
            return cart.license.some(function (license) {
                return license.fontRights.epub.ebooks;
            });
        }).length;

        vm.licenseTypes.Web.count = carts.filter(function (cart) {
            return cart.license.some(function (license) {
                return license.fontRights.web.views;
            });
        }).length;
    }

    vm.licenseTypes = {
        Desktop: { id: 'Desktop', count: 0 },
        Web: { id: 'Web', count: 0 },
        Application: { id: 'Application', count: 0 },
        Epub: { id: 'ePub', count: 0 },
    };
}
